import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
type TitleVariants = 'large' | 'medium' | 'small' | 'extraSmall' | 'smallCaption';

const Text: React.FC<{variant: TitleVariants; children: React.ReactNode; nativeClassname?: string}> = ({
  variant,
  children,
  nativeClassname
}) => {
  return <div className={classNames(styles.title, styles[variant], nativeClassname)}>{children}</div>;
};

export default Text;
